// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2-2v8","footer":"ModalCreateQualiphyProcedure_footer__2ODMa","additionData":"ModalCreateQualiphyProcedure_additionData__49zZt"};